/**
 * CustomFieldSection Component
 *
 * Handles the custom field management functionality
 */

import * as React from 'react';
import { CustomFieldManagerProps } from '../../types';
import { CustomFieldManager } from '../CustomFieldManager';

interface CustomFieldSectionProps {
	customFieldManagerProps: CustomFieldManagerProps;
	questionIndex: number;
	onValidationTrigger?: (questionIndex: number) => Promise<boolean>;
	onModalCreateCustomField: (handler: (() => void) | null) => void;
	onModalEditCustomField: (handler: (() => void) | null) => void;
}

export const CustomFieldSection: React.FC<CustomFieldSectionProps> = React.memo(
	({
		customFieldManagerProps,
		questionIndex,
		onValidationTrigger,
		onModalCreateCustomField,
		onModalEditCustomField,
	}) => {
		if (!customFieldManagerProps) {
			return null;
		}

		return (
			<CustomFieldManager
				{...customFieldManagerProps}
				questionIndex={questionIndex}
				onValidationTrigger={onValidationTrigger}
				onModalCreateCustomField={onModalCreateCustomField}
				onModalEditCustomField={onModalEditCustomField}
			/>
		);
	}
);

CustomFieldSection.displayName = 'CustomFieldSection';
